import { fetchFiwareDataType } from '../types';


/* ****************
 * fiwareデータのsourceIdを取得
 * ****************/
export const getFiwareSourceIds = (fiwareData: fetchFiwareDataType | undefined) => {
  if (!fiwareData) { return []; }
  return Object.keys(fiwareData).map((key) => key);
}
